import React, { Fragment, useRef, useState } from 'react';
import { Card, Row, Col, Divider, Button, message, Modal } from 'antd';
import { ReloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { apiClearConsumptionCache } from '@services/ManageDevices/DeviceServices';
import StatisticsCards from './components/StatisticsCards';
import ConsumptionChart from './components/ConsumptionChart';
import DeviceAllocationChart from './components/DeviceAllocationChart';
import DeviceStatusCharts from './components/DeviceStatusCharts';
import CustomerDeviceCharts from './components/CustomerDeviceCharts';
import WarningStatistics from './components/WarningStatistics';
import ConsumptionComparison from './components/ConsumptionComparison';
import DashboardMap from './components/DashboardMap';
import List from './components/List';
import './index.css';

const DashboardV2 = () => {
  const consumptionChartRef = useRef();
  const [clearingCache, setClearingCache] = useState(false);

  const handleRefreshConsumption = async () => {
    Modal.confirm({
      title: 'Xác nhận',
      icon: <ExclamationCircleOutlined />,
      content:
        'Việc cập nhật dữ liệu tiêu thụ theo ngày sẽ mất thời gian khoảng 1 phút. Bạn có đồng ý không?',
      okText: 'Đồng ý',
      cancelText: 'Hủy',
      onOk: async () => {
        try {
          setClearingCache(true);
          await apiClearConsumptionCache();
          message.success('Đã cập nhật thành công');
          if (consumptionChartRef.current) {
            consumptionChartRef.current.refetch();
          }
        } catch (error) {
          console.error('Error clearing cache:', error);
          message.error('Không thể cập nhật vui lòng thử lại sau');
        } finally {
          setClearingCache(false);
        }
      }
    });
  };

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Bảng điều khiển', path: '/dashboard' }]}
        />
      </div>

      {/* Statistics Cards */}
      {/* <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col span={24}>
          <StatisticsCards />
        </Col>
      </Row> */}

      {/* Charts Row 1: Consumption by Branch and Device Status by Branch */}
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            title={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%'
                }}>
                <span>Biểu đồ tiêu thụ ngày</span>
                <Button
                  icon={<ReloadOutlined />}
                  size="small"
                  onClick={handleRefreshConsumption}
                  loading={clearingCache}
                  style={{ marginLeft: 'auto' }}>
                  Cập nhật
                </Button>
              </div>
            }
            bordered={false}
            style={{ height: '100%' }}
            headStyle={{ fontSize: '14px', padding: '8px 16px', minHeight: 'auto' }}
            bodyStyle={{ padding: '16px' }}>
            <ConsumptionChart ref={consumptionChartRef} />
          </Card>
        </Col>
        <Col xs={24} lg={12} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Card bordered={false} style={{ flex: 1 }} bodyStyle={{ padding: '16px' }}>
            <DeviceStatusCharts />
          </Card>
          <Card bordered={false} style={{ flex: 1 }} bodyStyle={{ padding: '16px' }}>
            <CustomerDeviceCharts />
          </Card>
        </Col>
      </Row>

      {/* Charts Row 1.2: Customer and Device Status Charts */}
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            title="Biểu đồ phân bổ khách hàng"
            bordered={false}
            style={{ height: '100%' }}
            headStyle={{ fontSize: '14px', padding: '8px 16px', minHeight: 'auto' }}
            bodyStyle={{ padding: '16px' }}>
            <DeviceAllocationChart />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <svg
                  className="warning-svg"
                  width="35"
                  height="30"
                  viewBox="0 0 45 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M43.7602 11.6036C43.5959 11.196 43.2108 10.9347 42.754 10.8576L42.7573 10.8434L36.5994 10.4438L37.8428 4.96555L37.8308 4.9645C37.8533 4.75028 37.8181 4.54084 37.7283 4.3531C37.6384 4.16537 37.4963 4.00461 37.3135 3.88382C37.1296 3.76376 36.9103 3.6873 36.6733 3.66063C36.4362 3.63395 36.1882 3.65782 35.9492 3.73029L35.9443 3.71831L29.987 6.11987L27.9936 1.17495L27.9814 1.17985C27.8791 0.998086 27.7261 0.845608 27.5346 0.734745C27.3431 0.623881 27.1185 0.557742 26.879 0.541678C26.6389 0.526217 26.3907 0.561684 26.1547 0.645175C25.9188 0.728665 25.7017 0.857809 25.5214 1.02205L25.5099 1.01436L21.2808 5.64993L16.6879 2.63258L16.6794 2.64188C16.4798 2.5413 16.2498 2.48666 16.008 2.48239C15.7662 2.47813 15.5193 2.52435 15.2874 2.61733C14.7978 2.81471 14.4475 3.18878 14.301 3.60228L14.2851 3.60119L13.0487 9.04881L6.9792 8.65475L6.97664 8.66595C6.73322 8.67349 6.48793 8.73132 6.26059 8.83478C6.03325 8.93823 5.83025 9.08441 5.66799 9.26149C5.50632 9.43937 5.39025 9.64305 5.32916 9.85604C5.26808 10.069 5.26372 10.2853 5.31643 10.4874L5.30149 10.4934L7.2832 15.4093L1.41212 17.7761L1.41602 17.7858C1.19396 17.8994 0.999072 18.0542 0.847117 18.2377C0.695161 18.4211 0.5904 18.6281 0.5413 18.8419C0.493317 19.0559 0.50251 19.2704 0.568133 19.4682C0.633756 19.6659 0.753965 19.8412 0.919026 19.9799L0.9089 19.9915L5.49832 23.0065L1.3081 27.5996L1.31772 27.6059C1.17654 27.7952 1.08431 28.0055 1.04847 28.2199C1.01264 28.4342 1.03421 28.6465 1.11144 28.8396C1.27575 29.2472 1.66104 29.509 2.1177 29.5856L2.11441 29.5998L8.27231 29.9994L7.02889 35.4777L7.04071 35.4783C7.01824 35.6925 7.05336 35.902 7.14323 36.0897C7.2331 36.2774 7.3752 36.4382 7.55804 36.559C7.7419 36.679 7.96122 36.7555 8.19825 36.7822C8.43527 36.8088 8.68333 36.785 8.92232 36.7125L8.92733 36.7249L14.8842 34.3236L16.8774 39.2681L16.8896 39.2632C17.092 39.6185 17.4866 39.8684 17.9919 39.9013C18.2321 39.9164 18.4801 39.8807 18.716 39.7973C18.9519 39.7138 19.169 39.5849 19.3496 39.421L19.361 39.4287L23.5901 34.7931L28.183 37.8104L28.1915 37.8011C28.3911 37.9017 28.6211 37.9564 28.8629 37.9606C29.1047 37.9649 29.3516 37.9187 29.5836 37.8257C30.0732 37.6283 30.4234 37.2542 30.5701 36.8412L30.5853 36.8421L31.8217 31.3944L37.8917 31.7883L37.8943 31.7771C38.1377 31.7695 38.383 31.7117 38.6104 31.6082C38.8377 31.5048 39.0407 31.3586 39.2029 31.1815C39.3646 31.0036 39.4807 30.8 39.5418 30.587C39.6029 30.374 39.6072 30.1577 39.5545 29.9556L39.5695 29.9496L37.5879 25.0342L43.4596 22.6672L43.4557 22.6575C43.6777 22.5439 43.8726 22.3891 44.0246 22.2056C44.1765 22.0221 44.2813 21.8151 44.3304 21.6014C44.3784 21.3873 44.3693 21.1726 44.3036 20.9748C44.2379 20.777 44.1177 20.6016 43.9525 20.4629L43.9628 20.4518L39.3734 17.4368L43.5636 12.8436L43.554 12.8373C43.6951 12.648 43.7874 12.4377 43.8232 12.2234C43.859 12.0091 43.8375 11.7968 43.7602 11.6036Z"
                    fill="#D5002E"></path>
                  <rect x="20" y="11" width="4" height="13" fill="white"></rect>
                  <rect x="20" y="26" width="4" height="3" fill="white"></rect>
                </svg>
                <span>Cảnh báo</span>
              </div>
            }
            bordered={false}
            style={{ height: '100%' }}
            headStyle={{ fontSize: '14px', padding: '8px 16px', minHeight: 'auto' }}
            bodyStyle={{ padding: '16px' }}>
            <WarningStatistics />
          </Card>
        </Col>
      </Row>

      {/* Charts Row 2: Consumption Comparison and Warning Statistics */}
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            title="Biểu đồ tiêu thụ theo kỳ cước"
            bordered={false}
            style={{ height: '100%' }}
            headStyle={{ fontSize: '14px', padding: '8px 16px', minHeight: 'auto' }}
            bodyStyle={{ padding: '16px' }}>
            <ConsumptionComparison />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card
            title="Bản đồ vị trí các thiết bị có cảnh báo & Offline"
            bordered={false}
            style={{ height: '100%' }}
            headStyle={{ fontSize: '14px', padding: '8px 16px', minHeight: 'auto' }}
            bodyStyle={{ padding: '0px' }}>
            <DashboardMap />
          </Card>
        </Col>
      </Row>

      <Divider />
      {/* Device List Table */}
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <List />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default DashboardV2;
